import React from 'react';
import {Route , Link} from 'react-router-dom';
import { CurrencySelector} from '../../_components';
import { ExchangePage } from '../ExchangePage';
import { currencyServices , transactionService , userService } from '../../_services'
import { BankInfo } from '../ProfilePage/BankInfo'
import { connect } from 'react-redux';
import request from 'superagent';
import { utils} from '../../_helpers';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { currencyTypeConstants } from '../../_constants';

class WithdrawPage extends React.Component{
    
    constructor(props){
        super(props);

        this.state = {
            currencies : [] , 
            currency : '' ,
            currencyId : 0 ,  
            amount : '', 
            bankName : '' , 
            bankAccount : '' , 
            walletAddress : '' , 
            list : [] ,
            pages : 0 , 
            list_loading : true , 
            currencyType : '' ,
            disableSubmit : false , 
            isHWGCash : false , 
            memberBanks : null  , 
            selectedBankId : 0 , 
            selectedMemberBank : null 
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleCurrencyDropdown = this.handleCurrencyDropdown.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onFetchData = this.onFetchData.bind(this);
    }

    componentDidMount(){

        //get currencies for withdrawal form 
       currencyServices.GetMemberWalletAvailableCurrency('All')
       .then(response => {

            if(response){
                this.setState({
                    currencies : response
                })
            }
       })

       userService.getMemberBanks(this.props.authentication.user.id)
       .then(response => {
           if(response){
               this.setState({
                   memberBanks : response
               })
           }
       })
    }

    onFetchData(state , instance){
        const { authentication } = this.props;

        state.page += 1;    //fix react table state started from one 
        
        transactionService.getMemberWithdrawalList(state.page , state.pageSize , authentication.user.id)
        .then(response => {
            if(response){
                //update state with list 
                this.setState({
                    list : response.list , 
                    pages : response.pages , 
                    list_loading : false
                })
            }
        })
    }
    
    handleChange(event){

        this.setState ({
            [event.target.name] : event.target.value  //update state of corresponding input name 
        }, ()=> {
            
                //update selectedmemberbank (this callback should be for dropdown only )
                this.state.memberBanks && 
                this.state.memberBanks.map((item)=>{
                    if(this.state.selectedBankId == item.id){
                        
                        this.setState({
                            selectedMemberBank : item
                        })
                    }
                });
        })
    }

    handleMemberBankUpdate (){

    }
    
    handleCurrencyDropdown(event){
        this.setState ({
            currency : event.target.value, 
            currencyType : event.target.selectedOptions[0].getAttribute('data-type') , 
            isHWGCash : event.target.value === "HWGCash" ? true : false
        })
    }

    handleSubmit(event){
        event.preventDefault();
        
        const { currency , amount ,  walletAddress , isHWGCash  , selectedMemberBank  } = this.state; 
        const { authentication } = this.props;
        
        let formBody = {
            currency : currency ,  
            amount : amount , 
            memberId : authentication.user.id , 
            walletAddress : walletAddress , 
            memberBank : selectedMemberBank
        }

        this.setState({
            disableSubmit : true
        });

        transactionService.createMemberWithdrawal(formBody);

    }

    render(){
        const {loading} = this.props;
        const { currencies , currency , amount , currencyType , isHWGCash , selectedBankId , selectedMemberBank , 
                list , pages , list_loading , page , bankAccount , bankName , walletAddress , memberBanks
        } = this.state;

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ;  

        //define table columns 
        const columns = [
            {
                Header: 'Order Date',
                accessor: 'createdstr'  
            }, 
            {
                Header: 'Currency',
                accessor: 'currency'  
            }, 
            {
                Header: 'Qty / Amount',
                accessor: 'amount'  
            }, 
            {
                Header: 'Status',
                accessor: 'status'  , 
                Cell: row => (
                    <span className={`tag is-${row.value}`}>
                       {row.value}
                    </span>
                )  
            }, 
        ]
        
        return (
            <section className="section m-t-xs m-b-lg">
                <div className="container">
                    <div className="columns">
                        <div className="column is-6">
                            <form onSubmit={this.handleSubmit} className="default-form is-clearfix">
                                <h4>Withdrawal Request Form</h4>

                                <div className="has-instruction">
                                    1. Select Asset and fill in amount or volume to withdraw
                                </div>

                                <div className="field is-horizontal m-t-md">
                                    <div className="field-label is-small">
                                        <label className="label">Asset</label>
                                    </div>
                                    <div className="field-body">
                                        {
                                            currencies.length > 0 ? ( 
                                            <div className="select is-fullwidth">
                                            <CurrencySelector currencies={currencies} currency={currency}
                                                             handleChange={this.handleCurrencyDropdown} defaultText='Select withdrawal currency'/>
                                            
                                            </div>
                                            )
                                            :
                                            (
                                                <span>Wallet currently empty</span>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="field is-horizontal">
                                    <div className="field-label is-small">
                                        <label className="label">Quantity</label>
                                    </div>
                                    <div className="field-body">
                                        <input className="input is-small" onChange={this.handleChange} name="amount" value={amount} type="text" placeholder="Quantity to withdraw" 
                                        required
                                        />
                                    </div>
                                </div>

                                <div className="has-instruction">
                                    2. Bank Details / Wallet Address
                                </div>
                                {
                                    (currencyType === currencyTypeConstants.CURRENCYTYPE_DIGITAL_ASSET || isHWGCash) && 
                                    <React.Fragment>
                                    <div className="field is-horizontal">
                                        <div className="field-label is-small">
                                            <label className="label">{currency} Wallet Address</label>
                                        </div>
                                        <div className="field-body">
                                            <input className="input is-small" onChange={this.handleChange} name="walletAddress" value={walletAddress} type="text" placeholder={`${currency} wallet for transfer`} />
                                        </div>
                                    </div>
                                    
                                    </React.Fragment>
                                    
                                }    
                                {
                                    
                                    (currencyType === currencyTypeConstants.CURRENCYTYPE_CASH && !isHWGCash) && 
                                    <React.Fragment>
                                    
                                        <div className="field is-horizontal m-t-lg">
                                            <div className="field-body">  
                                                <div className="select is-fullwidth">
                                                    {
                                                        memberBanks ? (
                                                            
                                                            <select value={selectedBankId} name="selectedBankId" onChange={this.handleChange}>
                                                                <option>Select Your Bank</option>                                     
                                                                {
                                                                    memberBanks.length > 0  && 
                                                                    memberBanks.map((item)=>{
                                                                        return (
                                                                            <option value={item.id}>{item.benefBankName}</option>
                                                                        )
                                                                    })   
                                                                }
                                                            </select>
                                                        ) 
                                                        :(
                                                            <div>No Wire Information , please <a href='/account/profile' target="_blank">Update here</a></div>
                                                        )
                                                    }
                                                </div>     
                                            </div>
                                            
                                        </div>
                                        {
                                            selectedMemberBank && 
                                            <BankInfo memberBank = {selectedMemberBank} handleMemberBankUpdate={this.handleMemberBankUpdate} iteration="1" disableForm={true}/> 
                                        }
                                    </React.Fragment>
                                }                            
    

                                <div className="control m-t-lg is-pulled-right">
                                    <input type="submit" disabled={disableSubmit} className="button button-submit" value="Submit Withdrawal"/>
                                </div>
                                
                            </form>
                        </div>
                        

                        <div className="column is-6">
                            <h4>Withdrawal Orders</h4>
                            
                            <div className=" m-t-md">
                                <ReactTable
                                    manual
                                    data={list}
                                    pages={pages}
                                    loading={list_loading}
                                    columns={columns}
                                    defaultPageSize = {5} 
                                    onFetchData = {this.onFetchData}
                                    className="-striped -highlight"
                                    NoDataComponent = { ()=> { return []} }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    const {  authentication } = state;
    return {
         authentication
    };
}

const connectedPage = connect(mapStateToProps)(WithdrawPage);
export { connectedPage as WithdrawPage }; 



// WEBPACK FOOTER //
// ./src/Views/WithdrawPage/WithdrawPage.jsx